import { render } from "./UpSkillInformation.vue?vue&type=template&id=0d94f2bc&scoped=true&ts=true"
import script from "./UpSkillInformation.vue?vue&type=script&lang=ts"
export * from "./UpSkillInformation.vue?vue&type=script&lang=ts"

import "./UpSkillInformation.vue?vue&type=style&index=0&id=0d94f2bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d94f2bc"]])

export default __exports__